import { render, staticRenderFns } from "./showImageBox.vue?vue&type=template&id=bafa9ba0&scoped=true"
import script from "./showImageBox.vue?vue&type=script&lang=js"
export * from "./showImageBox.vue?vue&type=script&lang=js"
import style0 from "./showImageBox.vue?vue&type=style&index=0&id=bafa9ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa9ba0",
  null
  
)

export default component.exports